import React, { PureComponent } from 'react';
import _ from 'lodash'
import {
  Card, CardBody, Col, Button, ButtonToolbar, Container, Row, Table,Modal,
} from 'reactstrap';
import { MDBDataTable, MDBBtn, MDBTable, MDBTableBody, MDBTableHead  } from 'mdbreact';
import axios from "axios";
import Select from 'react-select';
/*import './App.css';*/
import { Multiselect } from 'multiselect-react-dropdown';
import { Dropdown } from 'semantic-ui-react'

import { Field, reduxForm } from 'redux-form';
import EyeIcon from 'mdi-react/EyeIcon';
import EmailIcon from 'mdi-react/EmailIcon';
import AccountSearchIcon from 'mdi-react/AccountSearchIcon';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import renderFileInputField from '../../../../shared/components/form/FileInput';
import renderSelectField from '../../../../shared/components/form/Select';
import renderMultiSelectField from '../../../../shared/components/form/MultiSelect';
import Util from '../../../Common/util';
import API from '../../../Common/api';
import {addAnalytics, paginationAnalytics} from '../../../Common/analytics';

const options= [];
var url = window.location.hostname;
var port = window.location.port;

class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.toggle = this.toggle.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.fetchGRNData = this.fetchGRNData.bind(this);
    this.result = this.result.bind(this);
    this.onChangeVal = this.onChangeVal.bind(this);
    this.btnClick = this.btnClick.bind(this);
    this.processData = this.processData.bind(this);
    this.togglePressCancel = this.togglePressCancel.bind(this);
    this.messagetoggle = this.messagetoggle.bind(this);
    this.cancelMessageModal = this.cancelMessageModal.bind(this);
    
   this.accessCookie = this.accessCookie.bind(this);
    this.multiSelectEl = []

    this.state = {
      showPassword: false,
      loadingGRNData: false,
      schemas: [],
      showFetchGRNData: false,
      Failedmodal: false,
      loadingprintbtn: false,
      showErrMsg: false,
      grnNumber: '',
      grnValues: '',
      grnLineValue: '',
      selectedOptions: '',
      changeStatus: '',
      alertMessage: '',
      messageModal: false,
      showRedirectButton: false,
      postsGRN: [],
      postsProduct: [],
      tableRowsGRN: [],
      ErrorRowData: [],
      options: [],
      newArrayData: [],
      selectedUser: {},
      showAssignButton: true,
      enableAssign: false,
      showPrintButton: false,
      value: "0",
      is_mrsl : false
    
    };

  }

  result(params) {
  }




  componentWillMount(){

      if (window.location.port == 8091 || window.location.port === ":8090") {
          port = ":8090"
        }else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    }else{
          port = ":8088"
        }

      if (url === "localhost") {
        url= "15.206.34.41" + ":8090";

      }else{
        url= window.location.hostname + port;
      }

      var cookieUsername = this.getCookie('token');
      var Location = this.getCookie('selectedLocation');
      var username = this.accessCookie("token");
      var is_mrsl  = this.accessCookie("is_mrsl");
      this.setState({
        userName: cookieUsername,
        selectedLocation: Location,
        is_mrsl : is_mrsl

      })

      localStorage.setItem('userName' , username);
    }

    Failedtoggle = ()=> {
      this.setState((prevState) => ({ Failedmodal: !prevState.Failedmodal }));
    }



   

  accessCookie(cookieName)
        {
          var name = cookieName + "=";
          var allCookieArray = document.cookie.split(';');
          for(var i=0; i<allCookieArray.length; i++)
          {
            var temp = allCookieArray[i].trim();
            if (temp.indexOf(name)==0)
            return temp.substring(name.length,temp.length);
         }
        return "";
        } 


        getCookie(cname) {
          var name = cname + "=";
          var decodedCookie = decodeURIComponent(document.cookie);
          var ca = decodedCookie.split(';');
          for(var i = 0; i <ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
              c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
              return c.substring(name.length, c.length);
            }
          }
          return "";
        }







messagetoggle(){
  this.setState({
    messageModal: true,
  })
}

cancelMessageModal(){
  this.setState({
    messageModal: false,
  })
}

processData1 = ()=>{
    var payloadArray = []

   for(var i= 0; i< this.state.postsGRN.length ; i++){
    var obj = {};

    obj['putawayHistoryId'] = this.state.postsGRN[i].putawayHistoryId;
    obj['userId'] = 37;


    payloadArray.push(obj);


   }
   addAnalytics('Putaway Assign User', 'Putaway Assign User');


   const payload = {
      
        arr_data: payloadArray,
        location: this.state.selectedLocation,
        create: true,
  };

API.post('/picking/updatePrintStatus/v1/', { param: payload })
      .then((response) =>  {

        if(response.data["success_response"].length == 0){
          if(response.data["failure_response"].length > 0){
            alert(response.data["failure_response"][0].reason);

             return false;
          }
        }
        /*alert(response.data.success_response[0].message);
        this.fetchGRNData();*/
        var new_data = {};

        for(var i=0;i < response.data["success_response"].length;i++){
             var tmp = response.data["success_response"][i];
             if(new_data[tmp.userName] == undefined){
                 new_data[tmp.userName] = [response.data["success_response"][i]];
             }else{
                  new_data[tmp.userName].push(response.data["success_response"][i]);
             }
        
}

        localStorage.setItem('printData' , JSON.stringify(new_data));

        /*window.location.href="/print_data";*/
       /* if (window.location.href="/putaway/printPutaway") {
          window.location.reload();
        }*/

        this.setState({
          loadingprintbtn: false,
          modal: false,
          showAssignButton: false,
          showPrintButton: true,
        })
        //this.fetchGRNData();
        window.open('/print_data','_blank');
         
      })
      .catch(function (error) {
        
        
        
    });





}

  processData(){
    this.setState({
      loadingprintbtn: true,
    })
    const { selectedUser, newArrayData } = this.state
    let payloadArray = []
    let printData = []
    const uniqueZoneData = {}
    let selectedUserLength = {}
    newArrayData.map(item => {
      if(!uniqueZoneData[item.zoneId]){
        uniqueZoneData[item.zoneId] = []
      }
      uniqueZoneData[item.zoneId].push(item)
    })
    _.map(uniqueZoneData, (item, key) => {
      if(this.state.selectedUser[key] === undefined){
     this.setState({
      loadingprintbtn: false,
    }, () => {alert("Assign all Zone to users");});
    
    return false;
    }
      let item_per_user = parseInt (item.length / this.state.selectedUser[key].length);

      let inc = 0
      let userIndex = 0

      /*let userIndex = 0*/
      item.map((putawayHistoryItem, index) => {
        let userId = selectedUser[key][userIndex]["value"];
        payloadArray.push({
          putawayHistoryId: putawayHistoryItem.putawayHistoryId,
          userId: userId
        })
        printData.push({
          userId: userId,
          data: putawayHistoryItem
        })

        if ( inc%item_per_user == 0) {
          userIndex++
        }


        /*userIndex++*/
        if(!selectedUser[key][userIndex]){
          userIndex = 0
        }
      })
    })

      const payload = {
      
        arr_data: payloadArray,
        location: this.state.selectedLocation,
        create: true,
  };

API.post('/picking/updatePrintStatus/v1/', { param: payload })
      .then((response) =>  {

        /*alert(response.data.success_response[0].message);
        this.fetchGRNData();*/
        var new_data = {};

        for(var i=0;i < response.data["success_response"].length;i++){
             var tmp = response.data["success_response"][i];
             if(new_data[tmp.userName] == undefined){
                 new_data[tmp.userName] = [response.data["success_response"][i]];
             }else{
                  new_data[tmp.userName].push(response.data["success_response"][i]);
             }
        
}
        localStorage.setItem('printData' , JSON.stringify(new_data));

        this.setState({
          loadingprintbtn: false,
          modal: false,
          showAssignButton: false,
          showPrintButton: true,
        })
        //this.fetchGRNData();
        window.open('/print_data','_blank');
         
      })
      .catch(function (error) {
        
        
        
    });



  }

  togglePressCancel(){
    this.setState({
        modal: false,
        selectedOptions: '',
        selectedUser: {},
    })
  }

  handleChange(event) {
        this.setState({value: event.target.data,
                        grnValues: event.target.value,


        });


        localStorage.setItem('grnValues' , event.target.value)

      }
    
   submitclick = () => {
    this.fetchGRNData()
  }

      onChangeVal = (options, id) => {
        const { selectedUser } = this.state
        selectedUser[id] = options;
        this.setState({
          selectedUser
        }, e => console.log(this.state.selectedUser))
      }


btnClick(putAwayId, Status){
 /* options=[];*/

  if (Status === 'UNHOLD') {
    this.setState({
       changeStatus: 'hold'
    })
  } else{
    this.setState({
      changeStatus: 'unhold'
    })
  }

    var arr=[]
    var orderData  = {};
          orderData['putawayHistoryId'] = putAwayId;

          if (Status=== 'UNHOLD') {
          orderData['changeStatus'] = 'hold';

          }else{
            orderData['changeStatus'] = 'unhold';

          }

          arr.push(orderData);

      const payload = {
        arr_data: arr,
        location: this.state.selectedLocation,
        create: true,
  };

API.post('/picking/updateHoldStatus/v1/', { param: payload })
      .then((response) =>  {
        /*alert(response.data.success_response[0].message);*/
        this.setState({
          alertMessage: response.data.success_response[0].message,
          messageModal: true
        })

        this.fetchGRNData();
         
      })
      .catch(function (error) {
        
        
    });



}


  fetchGRNData(){

      //var grnVal = localStorage.getItem('grnValues')
    if(this.state.grnValues == ""){
      this.setState({
        showErrMsg: true,

      })
      return false;
    }
      this.setState({
        showFetchGRNData: true,
        loadingGRNData: true,
       /* showAssignButton: true,
        showPrintButton: false*/
        

      })

      if(this.state.directPutawayFalg == 'false'){
         this.setState({
           showAssignButton: false,
        showPrintButton: false
         })
      }else{

         this.setState({
            showAssignButton: true,
            showPrintButton: false
             })

      }


      const payload = {
        grnLineNumber: this.state.grnValues, grnType: 1, location: this.state.selectedLocation
      };

      addAnalytics('Putaway Assign User', 'GRN Search Filter');

      API.post('/picking/fetchgrnInfo/v1/', { param: payload })
      .then(response => response.data)

      .then(data => {

        var product_id_array = [];

        if(data.length> 0){
          var arrayData= data.filter(item => item.eanMissing == true || item.lbhMissing == true || item.shelf_life == true || item.mrsl == true || (item.fail_reason && item.fail_reason.trim().length > 0));
        }else{
          this.setState({
            failed_message: data.reason
          })
          this.Failedtoggle();
          return false;
        }
         //var arrayData= data.filter(item => item.eanMissing == true || item.lbhMissing == true ); 

         if(arrayData.length > 0){
           this.setState({
              showRedirectButton: true,
              enableAssign: true
           })
         }else{
          this.setState({
            showRedirectButton: false,
            enableAssign: false
          })
         }

         if(arrayData.length > 0){
          for(var i = 0; i < arrayData.length; i++){
            product_id_array.push(arrayData[i].product_id)
          }

         }

         localStorage.setItem("product_ids",JSON.stringify(product_id_array));
         

         this.setState({ postsGRN: data, grnValues: data[0].grnNumber, grnLineValue: data[0].gnrLineNumber})


      })

      .then(async() => {

         this.setState({ tableRowsGRN:this.assemblePostsGRN(), isLoading:false, loadingGRNData: false })


      });
  }


  assemblePostsGRN = () => {
  const { postsGRN, is_mrsl } = this.state;

  return postsGRN.map((post, index) => {
    /* ---------- BIN ID MESSAGE ---------- */
    let binidmessage = "";

    if (!post.binId) {
      if (
        post.receivedIcldQuantity === 0 &&
        post.testerQuantity === 0 &&
        post.looseQuantity === 0
      ) {
        binidmessage = (
          <span style={{ color: "red" }}>Zero Quantity Uploaded</span>
        );
      } 
      else if (post.fail_reason && post.fail_reason.trim().length > 0){
        binidmessage = null
      }
      else {
        binidmessage = (
          <span style={{ color: "red" }}>No Space Available</span>
        );
      }
    } else {
      binidmessage = <span>{post.binId}</span>;
    }

    /* ---------- MISSING DETAILS ---------- */
    const missingFields = [];

    if (post.eanMissing) missingFields.push("EAN");
    if (post.lbhMissing) missingFields.push("LBH");

    if (is_mrsl !== "false") {
      if (post.shelf_life) missingFields.push("SHELF LIFE");
      if (post.mrsl) missingFields.push("MRSL");
    }

    // include fail_reason if present
    if (post.fail_reason && post.fail_reason.trim().length > 0) {
      missingFields.push(post.fail_reason.trim());
    }

    const missing_details =
      missingFields.length > 0 ? (
        <span style={{ fontSize: 11, color: "red" }}>
          {missingFields.join(", ")}
        </span>
      ) : (
        <span />
      );

    /* ---------- STATUS ---------- */
    const status =
      post.status === "UNHOLD" ? (
        <span
          onClick={() => this.btnClick(post.putawayHistoryId, post.status)}
          style={{ color: "red", cursor: "pointer" }}
        >
          Hold
        </span>
      ) : (
        <span
          onClick={() => this.btnClick(post.putawayHistoryId, post.status)}
          style={{ color: "green", cursor: "pointer" }}
        >
          Unhold
        </span>
      );

    /* ---------- RETURN ROW ---------- */
    return {
      serial: index + 1,
      status,
      missing_details,
      binId: binidmessage,
      zone_name: post.zoneName,
      lbskuid: post.sku7Code,
      batch: post.batch,
      mrp: post.mrp,
      testerQuantity: post.outerQty,
      receivedIcldQuantity: post.receivedIcldQuantity,
      looseQuantity: post.looseQuantity,
      stnDate: post.stnDate,
      stnNumber: post.stnNumber,
      pkd: post.pkd,
      upc: post.upc,
      crateId: post.crateId,
    };
  });
};


  fetchUserList(){
           const payload = {
    location: this.state.selectedLocation,
  };

API.post('/auth/users/getusers', { param: payload })
      .then((response) =>  {
         for(var i = 0; i < response.data.length; i++) {
               // <---- Move declaration inside loop
              
            var orderData  = {};
              orderData['label'] = response.data[i].userName;
              orderData['value'] = response.data[i].userId;
              
              options.push(orderData);
              
          }


         
      })
      .catch(function (error) {
        
        
    });


  }

redirectMissingDetail = ()=>{
  window.location.href="/receiving/view_missing_product";  

}


  componentDidMount() {

   
      this.setState({
        showAssignButton: true,
        showPrintButton: false
      });


  
  


    
       const payload = {
     
        location: this.state.selectedLocation,
        grnType: 1,
        location: this.state.selectedLocation,
  };

API.post('/picking/fetchgrnList/v1/', { param: payload })
      .then((response) =>  {
        
        if (response.reason === "invalid token") {
        
          window.location.href = "http://localhost:3000/";
        }

         this.setState({
                   schemas: response.data
               });
      })
      .catch(function (error) {
       

        
        
        
    });

    this.fetchUserList();
  }

  toggle() {

   /* var directPutawayFalg = this.getCookie('direct_putaway_flag');

    if(directPutawayFalg == 'false'){
      this.processData1();


    }else{*/

      this.setState({ selectedUser: {}, selectedOptions: '', modal: true, newArrayData: [] });

      /*var newArray = this.state.postsGRN.filter(status='UNHOLD');*/
      var arrayCartData= this.state.postsGRN.filter(item => item.status ==='UNHOLD' && item.zoneName != null ); 
      this.setState({
        newArrayData: arrayCartData,
      })
    
    /*}*/
  }

  showPassword = (e) => {
    e.preventDefault();
    this.setState(prevState => ({ showPassword: !prevState.showPassword }));
  };

  render() {
    const { handleSubmit, reset, t } = this.props;
    const { showPassword, newArrayData, selectedUser } = this.state;
    const { modal } = this.state;
    const { messageModal, Failedmodal } = this.state;
    const uniqueZoneData = {}
    newArrayData.map(item => {
      if(!uniqueZoneData[item.zoneId]){
        uniqueZoneData[item.zoneId] = {
          zoneId: item.zoneId,
          zoneName: item.zoneName,
          items: []
        }
      }
      uniqueZoneData[item.zoneId].items.push(item)
    })

    const GRNData = {

      columns: [

        {

          label:'S No.',

          field:'serial',
          width: 180

        },

        {

          label:'Action',

          field:'status',
          width: 180

        },
        {

          label:'Missing Details',

          field:'missing_details',
          width: 180

        },

        {

          label:'BIN Id',

          field:'binId',
          width: 180

        },

        {

          label:'Zone Name',

          field:'zone_name',
          width: 180

        },


        {

          label:'Product Code',

          field:'lbskuid',
           width: 180

        },


        

        {

          label:'Batch',

          field:'batch',
           width: 180

        },

        {

          label:'MRP',

          field:'mrp',
           width: 180

        },

        {

          label:'Outer Qty',

          field:'testerQuantity',
           width: 180

        },

        {

          label:'Inner Qty',

          field:'receivedIcldQuantity',
           width: 180

        },

        

        {

          label:'Each Qty',

          field:'looseQuantity',
           width: 180

        },


        {

          label:'Doc Date',

          field:'stnDate',
           width: 180

        },

        {

          label:'Doc Number',

          field:'stnNumber',
           width: 180

        },

        {

          label:'PKD',

          field:'pkd',
           width: 180

        },

        {

          label:'UPC',

          field:'upc',
           width: 180

        },

        {

          label:'Crate/Loc',

          field:'crateId',
           width: 180

        },





      ],

      rows:this.state.tableRowsGRN,

    }
    return (
      <Col xl={12}>
        <Card>
          <CardBody style={{height: 80}}>

            <form className="form form--inline" onSubmit={handleSubmit}>
              
              <div className="form__form-group col-xl-4" style={{display: 'inline-flex'}}>
                
                <span className="form__form-group-label col-xl-5" style={{display: 'none', paddingTop: 6, paddingBottom: 6}} >Select GRN No.</span>
                

                
                <div className=" col-xl-8">
                <select className="form-control grn_line_no" style={{fontSize: 13, width: '95%', float: 'left'}}  onChange={this.handleChange}>
                  <option disabled selected value="" >Select GRN No.</option>
                  { 
                    (this.state.schemas && this.state.schemas.length > 0) && this.state.schemas.map((schema) => {
                      return (<option value={schema.grnLineNumber}> {schema.grnLineNumber}</option>);
                    })
                  }
                </select>
                <div style={{width: '95%', float: 'left'}}>
                {this.state.showErrMsg &&
                <span style={{color: 'red', fontSize: 12, width: '95%', float: 'left'}}> Please select GRN Number</span>

              }
              </div>
                </div>
        
        <div className="form__form-group col-xl-2">
                <ButtonToolbar className="form__button-toolbar">
                    <button color="primary" className="btn-sm button_enable" style={{fontWeight:'normal',textTransform:'capitalize',borderRadius: 5, backgroundColor:'#70bbfd', color:'#fff',padding: "5px 25px",fontSize: "14px"}} id="button_enable" onClick={this.submitclick} >
                    {this.state.loading && 
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    }

                    Allocate
                    </button>
                </ButtonToolbar>
              </div>
                
                
              </div>
            
            

              <div className="form__form-group col-xl-3">
               
                <div className="form__form-group-field">
                  
                </div>
                
              </div>
            
            </form>
      
          </CardBody>

          {this.state.showFetchGRNData &&

           <CardBody style={{marginTop: 8}}>
            <div className="table_header">
              <span> <span style={{fontWeight: 'bold'}}> GRN Number: </span> <span> {this.state.grnValues} / </span> <span style={{fontWeight: 'bold'}}> GRN Line Number: </span> <span> {this.state.grnLineValue}  </span></span>
              
             <ButtonToolbar className="form__button-toolbar">
                {this.state.showAssignButton &&
                <Button color="primary" disabled={this.state.enableAssign} className="btn-sm" onClick={this.toggle} type="submit" style={{textTransform:'capitalize'}}>Assign</Button>
                }
                 {this.state.showRedirectButton &&
                <Button color="primary" className="btn-sm" onClick={this.redirectMissingDetail} type="submit" style={{textTransform:'capitalize'}}>Update Details</Button>
                }
                {this.state.showPrintButton &&
                <Button color="primary" className="btn-sm" type="submit" style={{textTransform:'capitalize'}}>Print</Button>
                }
              </ButtonToolbar>
            </div>
            
            <div className="table_val">
            <MDBTable autoWidth striped>
              <MDBTableHead columns={GRNData.columns}/>
              <MDBTableHead>
               {this.state.loadingGRNData && 
                <div style={{width: '2300%', textAlign: 'center', paddingTop: 22}}>
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" , fontSize: 18 }}
                      />
                  </div>
              }

              </MDBTableHead>
              <MDBTableBody scrollX rows={GRNData.rows} />
            </MDBTable>
            </div>

         
          </CardBody>
        }
        </Card>

        <Modal
          isOpen={modal}
          toggle={this.toggle}
          style={{maxWidth: 700, height: 500, padding: 0}}
        >
          <div className="modal__header" style={{backgroundColor: '#70bbfd'}}>
            <h4 className="text-modal  modal__title" style={{color: '#fff', paddingTop: 10}}>Assign Users</h4>
          </div>
          <div className="modal__body" style={{padding: 14}}>
             <Table responsive className="table--bordered" style={{marginBottom: 75}}>
                    <thead>
                      <tr>
                        <th>Zone Id</th>
                        <th>Zone Name</th>
                        <th>Line Count</th>
                        <th>Users</th>

                        
                      </tr>
                    </thead>
                    <tbody>
                      {
                        Object.keys(uniqueZoneData).length>0  && (
                      
                        _.map(uniqueZoneData, (item, key) => (
                    
                        <tr key={key}>
                          <td>{item.zoneId}</td>
                          <td>{item.zoneName} </td>
                          <td>{item.items.length} </td>
                          <td>

                          <div className="form__form-group">
                            <div className="form__form-group-field">
                              <Select
                                isMulti
                                name={`multiSelect_${item.zoneId}`}
                                value={selectedUser[item.zoneId]}
                                onChange={selectedOptions => this.onChangeVal(selectedOptions, item.zoneId)}
                                options={options}
                                clearable={true}
                                closeOnSelect={true}
                                removeSelected={true}
                                className="react-select"
                                classNamePrefix="react-select"
                              />
                            </div>
                          </div>

                          </td>
                                           
                          
                        </tr>

                        )))}

                    
                     


                    </tbody>
                  </Table>

                  <ButtonToolbar className="modal__footer">
                    <button style={{textTransform:'capitalize'}} className="modal_cancel"  onClick={this.togglePressCancel}>Cancel</button>
                    <Button style={{backgroundColor: '#24d6a3', color: '#fff', marginLeft: 12,textTransform:'capitalize'}} className="modal_ok"  onClick={this.processData}>
                    {this.state.loadingprintbtn && 
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    }
                    Print</Button>
                  </ButtonToolbar>
          </div>
          
        </Modal>


         <Modal
          isOpen={messageModal}
          toggle={this.messagetoggle}
        >
          <div className="modal__header">
            
            <button className="lnr lnr-cross modal__close-btn" type="button" style={{right: 15}} onClick={this.toggle} />
           
          </div>
          <div className="modal__body" style={{paddingTop: 55, paddingBottom: 20}}>
            <span className="lnr lnr-thumbs-up modal__title-icon" style={{color: '#4ce1b6'}} />
            
            <h4> {this.state.alertMessage} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button style={{backgroundColor: '#24d6a3', color: '#fff',textTransform:'capitalize'}} className="modal_ok"  onClick={this.cancelMessageModal}>Ok</Button>
          </ButtonToolbar>
        </Modal>

         <Modal
          isOpen={Failedmodal}
          backdrop="static"
          toggle={this.Failedtoggle}
        >
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.toggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-cross-circle modal__title-icon"
              style={{ color: "red" }}
            />
            <h4>{this.state.failed_message} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.Failedtoggle}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>


      </Col>
    );
  }
}

export default reduxForm({
  form: 'Upload Master', // a unique identifier for this form
})(withTranslation('common')(HorizontalForm));
